export default __webpack_public_path__ + "static/green-lightbulb-af58de3e676fc84d7e09b48f06ee4168.png";